//
//
//
//

import { getMonthDay } from '~/assets/js/utils.js'
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    lineData: {
      type: Array,
      default: () => [{
        name: '2022-3-20',
        value: 11,
        value1: 22
      }, {
        name: '2022-3-21',
        value: -13,
        value1: -23
      }, {
        name: '2022-3-22',
        value: 12,
        value1: 22
      }, {
        name: '2022-3-23',
        value: 11,
        value1: 22
      }, {
        name: '2022-3-24',
        value: -12,
        value1: -22
      }, {
        name: '2022-3-25',
        value: 13,
        value1: 23
      }, {
        name: '2022-3-26',
        value: 11,
        value1: 22
      }, {
        name: '2022-3-27',
        value: 13,
        value1: 24
      }]
    }
  },
  data () {
    return {
      myChart: null // 图表实例
    }
  },
  watch: {
    // 监听屏幕宽度的变化
    '$store.state.screenWidth' (newV) {
      this.myChart?.resize()
    },
    lineData: {
      handler (newVal) {
        this.getLineCharts()
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getLineCharts()
    })
  },
  beforeDestroy () {
    this.myChart?.clear() // 清空当前实例
    this.myChart?.dispose() // 销毁图表
    this.myChart = null
  },
  methods: {
    getLineCharts () {
      const [xData, data1, data2] = [[], [], []]
      this.lineData.forEach((item) => {
        xData.push(getMonthDay((item.timestamp + '000') - 0))
        data1.push({
          name: getMonthDay((item.timestamp + '000') - 0),
          value: item.industry
        })
        data2.push({
          name: getMonthDay((item.timestamp + '000') - 0),
          value: item.value
        })
      })
      this.myChart = this.$echarts.init(document.getElementsByClassName('spot-charts')[0])
      const option = {
        grid: {
          top: '15%',
          bottom: '10%',
          right: 0,
          left: '2%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xData,
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#A3A3A3',
              margin: 30
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: '#A3A3A3'
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: ['rgba(0, 0, 0, 0.05)']
              }
            }
          }
        ],
        tooltip: {
          confine: true,
          trigger: 'axis',
          backgroundColor: 'rgba(0,0,0,0.7)',
          formatter: (params) => {
            return `<div class="tooltip-box">
            <div class="item">${params[0].name}</div>
            <div class="item item1"><span>${this.name}</span>:<span>${params[0].value}</span></div>
            <div class="item item1">${this.$t('12806')}:${params[1].value}</div>
            </div>`
          },
          axisPointer: {
            type: 'none'
          }
        },
        series: [
          {
            name: '',
            type: 'bar',
            barMaxWidth: 16,
            barMinHeight: 10,
            itemStyle: {
              normal: {
                color: '#5C8AE5'
              },
              emphasis: {
                color: '#96B9FF'
              }
            },
            data: data2
          },
          {
            type: 'line',
            data: data1,
            smooth: true, // 平滑曲线
            showSymbol: false,
            symbol: 'none',
            lineStyle: {
              color: '#F5BC49'
            }
          }
        ]
      }
      this.myChart?.setOption(option, true)
    }
  }
}
